module.exports = __webpack_public_path__ + "img/CS2code.01e0932b.png";